import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  Dimensions,
} from "react-native";
import { FontAwesome5, Feather, MaterialIcons } from "@expo/vector-icons";
import NumberFormat from "react-number-format";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import { useIsFocused } from "@react-navigation/native";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { apiservice } from "../../service/service";
import { getActionUser } from "../../action/actionlogin";
const { width, height } = Dimensions.get("window");

export default function home({ navigation }) {
  const focus = useIsFocused();
  const token = useRecoilValue(tokenState);
  const [data, setDashboardData] = useState({});

  async function fetchDashBoardData() {
    const response = await apiservice({
      path: "/admin/getallhome",
      method: "get",
      token: token?.accessToken,
    });
    if (response.status == 200) {
      setDashboardData(response.data);
      return
    }

    navigation.navigate("Login");
  }

  async function getAdminInformation() {
    const results = await getActionUser(token)
    if (results.status == 200) {
      console.log('====================================');
      console.log(results.data.data.event_id);
      console.log('====================================');
      if (results.data.data.event_id) {
        navigation.navigate("HomeEvent");
      }

      return
    }

    navigation.navigate("Login");
  }

  useEffect(() => {
    fetchDashBoardData();
    getAdminInformation();
  }, [focus]);

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <View style={styles.back}>
        <Admin navigation={navigation} />
        <View style={styles.main}>
          <View style={styles.view}>
            <View>
              <Text style={styles.text}>USER</Text>
              <Text style={styles.text1}>
                <NumberFormat
                  value={data?.user}
                  displayType={"text"}
                  thousandSeparator={true}
                />
              </Text>
            </View>
            <View style={[styles.imgicon, { backgroundColor: "#2DCE98" }]}>
              <FontAwesome5
                name="user-alt"
                size={25}
                color="#fff"
                style={{ alignSelf: "center" }}
              />
            </View>
          </View>
          <View style={styles.view}>
            <View>
              <Text style={styles.text}>EVENT</Text>
              <Text style={styles.text1}>
                <NumberFormat
                  value={data.event}
                  displayType={"text"}
                  thousandSeparator={true}
                />
              </Text>
            </View>
            <View style={[styles.imgicon, { backgroundColor: "#2DCE98" }]}>
              <Feather
                name="file-text"
                size={25}
                color="#fff"
                style={{ alignSelf: "center" }}
              />
            </View>
          </View>
        </View>
        <View style={styles.main}>
          <View style={styles.view}>
            <View>
              <Text style={styles.text}>FREE POINT</Text>
              <Text style={styles.text1}>
                <NumberFormat
                  value={data.freepoint}
                  displayType={"text"}
                  thousandSeparator={true}
                />
              </Text>
            </View>
            <View style={[styles.imgicon, { backgroundColor: "#7764E4" }]}>
              <FontAwesome5
                name="coins"
                size={24}
                color="#fff"
                style={{ alignSelf: "center" }}
              />
            </View>
          </View>
          <View style={styles.view}>
            <View>
              <Text style={styles.text}>DISCOUNT</Text>
              <Text style={styles.text1}>
                <NumberFormat
                  value={data.discount}
                  displayType={"text"}
                  thousandSeparator={true}
                />
              </Text>
            </View>
            <View style={[styles.imgicon, { backgroundColor: "#7764E4" }]}>
              <MaterialIcons
                name="card-giftcard"
                size={24}
                color="#fff"
                style={{ alignSelf: "center" }}
              />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: "1%",
    position: "absolute",
    right: 0,
  },
  view: {
    width: "48%",
    height: 120,
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    flexDirection: "row",
    padding: 20,
    justifyContent: "space-between",
  },
  main: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    alignSelf: "center",
    marginBottom: 30,
  },

  imgicon: {
    width: 50,
    height: 50,
    alignSelf: "center",
    justifyContent: "center",
    borderRadius: 25,
  },
  text: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#8898AA",
  },
  text1: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#4D4F5C",
  },
});
